<ng-template #content let-modal>
    <div class="modal-header">
        <h4>{{modalHeader}}</h4>
    </div>

    <div class="modal-body">
        <form>
            <div class="col-md-12 form-group">
                <label class="detail-name" for="recipients">To *</label>
                <input class="form-control" [(ngModel)]="rawRecipients" name="recipients" (input)="separateRecipients()">
            </div>

            <div class="col-md-12 form-group">
                <label class="detail-name" for="subject">Subject *</label>
                <input class="form-control" [(ngModel)]="data.subject" name="subject">
            </div>

            <div class="col-md-12 form-group">
                <label class="detail-name" for="body">Write a Message</label>
                <textarea class="form-control" [(ngModel)]="data.body" name="body" rows="5"></textarea>
            </div>
        </form>
        
        <span class="col-md-3">* Required</span>
    </div>

    <div class="modal-footer" style="border: none">
        <button *ngIf="!isWaiting" type="button" class="btn btn-outline-secondary btn-lg"
            (click)="modal.dismiss('Cross click')">Cancel</button>
        <button *ngIf="!isWaiting" [disabled]="!isInputValid()" type="button" class="btn btn-primary btn-lg"
            (click)="modalSubmitted()">{{submitButtonText}}</button>
        <app-loading-spinner *ngIf="isWaiting" text="Sending..."></app-loading-spinner>
    </div>

</ng-template>
